module.exports = __webpack_public_path__ + "static/media/ua_plain.81ccd979.svg";